import request from '@/utils/request'

export function getIndex() {
  return request({
    url: '/index/Policy/index',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function getPolicyList(query) {
  return request({
    url: '/index/Policy/getPolicyList',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}
